import React from "react";

import { ModalProvider } from "./src/context/context";

export const wrapRootElement = ({ element }) => (
  <ModalProvider>{element}</ModalProvider>
);
